/* ============================================================
   ARN gift card page (sections/arn-gift-card-main.liquid)
   Amount pills, quantity, Shopify gift card recipient form, and add to cart.
   Add to cart posts the whole form to /cart/add.js so the recipient line item
   properties go with it, then fires added.ajaxProduct so theme.js opens the
   cart drawer the same way it does for the bar pages.
   ============================================================ */
(function () {
  'use strict';

  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function isoDate(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }

  function init(section) {
    var form = section.querySelector('[data-arn-gift-form]');
    if (!form) return;

    var idInput = form.querySelector('[data-arn-gift-id]');
    var priceEl = form.querySelector('[data-arn-gift-price]');
    var submitBtn = form.querySelector('[data-arn-gift-submit]');
    var submitText = form.querySelector('[data-arn-gift-submit-text]');
    var submitWrap = submitBtn ? submitBtn.parentElement : null;
    var errorEl = form.querySelector('[data-arn-gift-error]');
    var announcer = section.querySelector('[data-arn-announcer]');
    var qtyInput = form.querySelector('[data-arn-gift-qty-input]');
    var toggle = form.querySelector('[data-arn-gift-toggle]');
    var fields = form.querySelector('[data-arn-gift-fields]');
    var dateInput = form.querySelector('[data-arn-gift-date]');
    var offsetInput = form.querySelector('[data-arn-gift-offset]');
    var message = form.querySelector('[data-arn-gift-message]');
    var count = form.querySelector('[data-arn-gift-count]');
    var slider = section.querySelector('.js-slider-for');

    function announce(text) {
      if (announcer) announcer.textContent = text;
    }

    function showError(text) {
      if (!errorEl) return;
      errorEl.textContent = text;
      errorEl.hidden = !text;
    }

    function setAvailable(available) {
      if (!submitBtn) return;
      submitBtn.disabled = !available;
      submitBtn.setAttribute('aria-disabled', available ? 'false' : 'true');
      if (submitText) submitText.textContent = available ? 'add to cart' : 'Sold Out';
      if (submitWrap) submitWrap.classList.toggle('arn-pdp-v2__atc--sold-out', !available);
    }

    function goToSlide(index) {
      if (index === '' || index === null || isNaN(index)) return;
      if (!slider || !window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) return;
      try { window.jQuery(slider).slick('slickGoTo', parseInt(index, 10)); } catch (e) { /* slider not ready */ }
    }

    // Amount pills
    form.querySelectorAll('input[name="arn-gift-amount"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        if (idInput) idInput.value = radio.value;
        if (priceEl) priceEl.textContent = radio.dataset.price;
        setAvailable(radio.dataset.available === 'true');
        goToSlide(radio.dataset.slide);
        showError('');
        announce(radio.dataset.price + ' gift card selected');
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', radio.value);
          window.history.replaceState({}, '', url.toString());
        } catch (e) { /* old browser */ }
      });
    });

    // Quantity
    function clampQty() {
      if (!qtyInput) return 1;
      var n = parseInt(qtyInput.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (n > 99) n = 99;
      qtyInput.value = n;
      return n;
    }
    form.querySelectorAll('[data-arn-gift-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var n = clampQty() + parseInt(btn.dataset.arnGiftQty, 10);
        qtyInput.value = n < 1 ? 1 : n;
        clampQty();
      });
    });
    if (qtyInput) qtyInput.addEventListener('blur', clampQty);

    // Send to someone (Shopify gift card recipient form). Fields stay disabled, so nothing is sent, until ticked.
    function setDateLimits() {
      if (!dateInput) return;
      var today = new Date();
      var max = new Date();
      max.setDate(max.getDate() + 90);
      dateInput.min = isoDate(today);
      dateInput.max = isoDate(max);
    }

    function setRecipientOpen(open) {
      if (!fields) return;
      fields.hidden = !open;
      fields.querySelectorAll('input, textarea').forEach(function (el) {
        el.disabled = !open;
        if (!open) el.removeAttribute('aria-invalid');
      });
      if (open) {
        setDateLimits();
        if (offsetInput) offsetInput.value = new Date().getTimezoneOffset();
        var first = fields.querySelector('input[type="email"]');
        if (first) first.focus();
      }
      showError('');
    }

    if (toggle) {
      toggle.addEventListener('change', function () { setRecipientOpen(toggle.checked); });
      setRecipientOpen(toggle.checked);
    }

    // Clear the message once the field it points at is being fixed.
    if (fields) {
      fields.addEventListener('input', function (e) {
        if (e.target.getAttribute('aria-invalid') === 'true') {
          e.target.removeAttribute('aria-invalid');
          showError('');
        }
      });
    }

    if (message && count) {
      var updateCount = function () { count.textContent = Math.max(0, 200 - message.value.length); };
      message.addEventListener('input', updateCount);
      updateCount();
    }

    function validateRecipient() {
      if (!toggle || !toggle.checked) return '';
      var email = fields.querySelector('input[type="email"]');
      if (email) {
        var ok = email.value.trim() !== '' && email.checkValidity();
        email.setAttribute('aria-invalid', ok ? 'false' : 'true');
        if (!ok) { email.focus(); return 'Add a valid email address for who it is going to.'; }
      }
      if (dateInput && dateInput.value) {
        var okDate = /^\d{4}-\d{2}-\d{2}$/.test(dateInput.value) && dateInput.value >= dateInput.min && dateInput.value <= dateInput.max;
        dateInput.setAttribute('aria-invalid', okDate ? 'false' : 'true');
        if (!okDate) { dateInput.focus(); return 'Pick a send date between today and 90 days from now.'; }
      }
      return '';
    }

    function readError(data) {
      if (!data) return 'Something went wrong adding the gift card. Please try again.';
      if (data.errors && typeof data.errors === 'object') {
        var parts = [];
        Object.keys(data.errors).forEach(function (key) {
          var val = data.errors[key];
          parts.push(Array.isArray(val) ? val.join(' ') : String(val));
        });
        if (parts.length) return parts.join(' ');
      }
      return data.description || data.message || 'Something went wrong adding the gift card. Please try again.';
    }

    form.addEventListener('submit', function (e) {
      if (typeof fetch === 'undefined' || typeof FormData === 'undefined') return; // native submit to /cart/add
      e.preventDefault();
      if (!submitBtn || submitBtn.disabled) return;

      clampQty();
      var problem = validateRecipient();
      if (problem) { showError(problem); return; }
      showError('');

      submitBtn.classList.add('is-loading');
      submitBtn.setAttribute('aria-busy', 'true');

      var body = new FormData(form);
      body.delete('arn-gift-amount');
      // Leave out optional recipient fields left blank, so the line only carries what was filled in.
      ['properties[Recipient name]', 'properties[Message]', 'properties[Send on]'].forEach(function (key) {
        if (body.has(key) && String(body.get(key)).trim() === '') body.delete(key);
      });

      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        body: body,
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) {
          return r.json().catch(function () { return null; }).then(function (data) { return { ok: r.ok, data: data }; });
        })
        .then(function (res) {
          if (!res.ok) { showError(readError(res.data)); return; }
          announce('Gift card added to cart');
          if (window.jQuery) window.jQuery('body').trigger('added.ajaxProduct');
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        })
        .catch(function () {
          showError('Could not reach the cart. Check your connection and try again.');
        })
        .then(function () {
          submitBtn.classList.remove('is-loading');
          submitBtn.removeAttribute('aria-busy');
        });
    });
  }

  function start() {
    document.querySelectorAll('[data-arn-gift]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
